import { render, staticRenderFns } from "./FieldCards.vue?vue&type=template&id=23c09319&scoped=true"
import script from "./FieldCards.vue?vue&type=script&lang=js"
export * from "./FieldCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c09319",
  null
  
)

export default component.exports